real.events.on('ai:synopsis:failed', notification => {
    const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${notification.object.uploaded_file.id}"] .card-content`);
    if (transcriptContainer.length === 0) {
        return;
    }
    const synopsisContainer = transcriptContainer.find('.synopsis-view-content');
    howspace.animate(synopsisContainer, 'fadeOut', 'fast', () => {
        synopsisContainer.removeClass('d-none');
        synopsisContainer.html(notification.object.error);
    });
});
